import axios from "axios";

// Utils
import { warn } from "./logger";
import { isLocal, isProd, fileUploadToken } from "./env";

const FileUploadAPI = axios.create({
  baseURL: isLocal
    ? `http://localhost:4000/api/v1`
    : isProd
    ? `https://avangrid.mbdt01.com/api/v1`
    : `https://avangridt.mbdt01.com/api/v1`,
});
FileUploadAPI.defaults.headers.common["Authorization"] = `Bearer ${fileUploadToken}`;
export default FileUploadAPI;
